import { render, staticRenderFns } from "./order-settlement-index.vue?vue&type=template&id=06b12a50&scoped=true"
import script from "./order-settlement-index.vue?vue&type=script&lang=js"
export * from "./order-settlement-index.vue?vue&type=script&lang=js"
import style0 from "./order-settlement-index.vue?vue&type=style&index=0&id=06b12a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b12a50",
  null
  
)

export default component.exports